export default __webpack_public_path__ + "static/media/feedback.d63ab783.jpg";